export default {
  name: 'bee',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#846d06',
  borderDarkest: '#0C1618',
  borderLight: '#e7c221',
  borderLightest: '#f8df6e',
  canvas: '#ffffff',
  canvasText: '#0C1618',
  canvasTextDisabled: '#846d06',
  canvasTextDisabledShadow: '#f8df6e',
  canvasTextInvert: '#ffffff',
  checkmark: '#0C1618',
  checkmarkDisabled: '#846d06',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#fefe03',
  headerBackground: '#0C1618',
  headerNotActiveBackground: '#7F7B82',
  headerNotActiveText: '#e5bd03',
  headerText: '#f8df6e',
  hoverBackground: '#0C1618',
  material: '#e5bd03',
  materialDark: '#7F7B82',
  materialText: '#0C1618',
  materialTextDisabled: '#846d06',
  materialTextDisabledShadow: '#f8df6e',
  materialTextInvert: '#ffffff',
  progress: '#0C1618',
  tooltip: '#fefbcc'
};
